import Swiper from 'Swiper'
import Waypoint from 'exports?Waypoint!waypoints/lib/noframework.waypoints.js'

/**
 * HeatAndServeProductsSlider functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class HeatAndServeProductsSlider {
  /**
   * Constructs a new HeatAndServeProductsSlider instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.swiperContainer = this.element.querySelector('.swiper-container')
    this.swiperPagination = this.element.querySelector('.swiper-pagination')
    this.swiperButtonPrev = this.element.querySelector('[data-component="swiper-button-prev"]')
    this.swiperButtonNext = this.element.querySelector('[data-component="swiper-button-next"]')
    const swiper = new Swiper(this.swiperContainer, {
      noSwiping: true,
      noSwipingClass: 'no-swiping',
      autoHeight: true,
      pagination: {
        el: this.swiperPagination,
        type: 'fraction'
      },
      effect: 'fade',
      loop: true,
      fadeEffect: {
        crossFade: true
      }
    })

    if (this.swiperButtonPrev) {
      this.swiperButtonPrev.addEventListener('click', () => {
        swiper.slidePrev()
      })
    }

    if (this.swiperButtonNext) {
      this.swiperButtonNext.addEventListener('click', () => {
        swiper.slideNext()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./components/heat-and-serve-products-slider/index.js